








































































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ConfirmModal from "@/components/modal/Confirm.vue";
import MessageForm from "./Form.vue";
import { MessageDto } from "@/store/messages/message.interface";
import Message from "@/store/messages";

@Component({
  components: {
    "message-form": MessageForm
  }
})
export default class AppMessageView extends Vue {
  isLoading: boolean = false;
  error: any = "";
  data: any = null;
  temp: any = null;
  id: number = 0;
  disabled: boolean = true;

  mounted() {
    this.sockets.subscribe("messageUpdated_" + this.id, (data: any) => {
      this.data = JSON.parse(JSON.stringify(data));
      this.temp = JSON.parse(JSON.stringify(data));
    });
  }

  destroyed() {
    this.sockets.unsubscribe("messageUpdated_" + this.id);
  }

  async created() {
    this.id = parseInt(this.$route.params.id);
    const res = await Message.findOne(this.id);
    this.data = JSON.parse(JSON.stringify(res.response.data));
    this.temp = JSON.parse(JSON.stringify(res.response.data));
  }

  onEditable() {
    this.disabled = false;
  }

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await Message.updateOne(this.id, form);
      const res = await Message.findOne(this.id);
      this.data = JSON.parse(JSON.stringify(res.response.data));

      this.disabled = true;
      this.isLoading = false;
      this.$toasted.success("Saved");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
      this.$toasted.error(this.error);
    }
  }

  async onConfirmRemove() {
    this.isLoading = true;
    try {
      await Message.removeOne(this.id);
      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("Removed");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
      this.$toasted.error(this.error);
    }
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  async onCancel() {
    this.data = JSON.parse(JSON.stringify(this.temp));
    this.disabled = true;
  }

  get getStatus() {
    switch (this.data.status_id) {
      case 1:
        const getPercentage = (
          (this.data.total_sync * 100) /
          this.data.total
        ).toFixed(2);
        return `Processing (${getPercentage}%)`;
      case 2:
        return "Queue";
      case 3:
        return "Sending";
      case 6:
        return "Paused";
      case 4:
        return "Done";
      case 5:
        return "Inactive";
    }
  }

  async onResume() {
    await Message.updateOne(
      this.data.id as number,
      {
        status_id: 3
      } as any
    );
  }

  async onPause() {
    await Message.updateOne(
      this.data.id as number,
      {
        status_id: 6
      } as any
    );
  }
}
